import { render, staticRenderFns } from "./Mepandes.vue?vue&type=template&id=5955bbae&scoped=true&"
import script from "./Mepandes.vue?vue&type=script&lang=js&"
export * from "./Mepandes.vue?vue&type=script&lang=js&"
import style0 from "./Mepandes.vue?vue&type=style&index=0&id=5955bbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955bbae",
  null
  
)

export default component.exports